<template>
    <el-card shadow="hover">
        <label slot="header">头像-重置密码-退出登录</label>
        <el-divider content-position="left">j-avatar</el-divider>
        <div style="width: 150px;">
            <j-avatar />
        </div>
    </el-card>
</template>

<script>
    import JAvatar from "./JAvatar";
    export default {
        components: {
            JAvatar
        },
        data() {
            return {}
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
